import { render, staticRenderFns } from "./IfPhoneNumber.vue?vue&type=template&id=48300748&scoped=true&"
import script from "./IfPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./IfPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./IfPhoneNumber.vue?vue&type=style&index=0&id=48300748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48300748",
  null
  
)

export default component.exports